import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'PaidLander',
})(({ brandColors, spacing, breakpoints, type, typography }, props) => ({
  container: {
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue20,
      brandColors.tintsOffWhite60
    ),
  },
  fullHeightContainer: {
    minHeight: `calc(100dvh - ${typography.pxToRem(80)} - ${typography.pxToRem(
      182
    )})`,
    [breakpoints.up('sm')]: {
      minHeight: `calc(100dvh - ${typography.pxToRem(
        80
      )} - ${typography.pxToRem(158)})`,
    },
    [breakpoints.up('md')]: {
      minHeight: `calc(100dvh - ${typography.pxToRem(
        80
      )} - ${typography.pxToRem(124)})`,
    },
    [breakpoints.up('lg')]: {
      minHeight: `calc(100dvh - ${typography.pxToRem(
        96
      )} - ${typography.pxToRem(204)})`,
    },
  },
  content: {
    [breakpoints.up('lg')]: {
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
    },
  },
  submitError: {
    color: brandColors.errorMain,
    ...type['14_medium'],
    marginBottom: spacing(0),
  },
  hiddenBackButton: {
    visibility: 'hidden',
  },
}));

export default useStyles;
